// page
const p = (path) => {
  return () => import(`@/pages/${path}.vue`).then((m) => m.default || m);
};

// page layout
const pl = (path) => {
  return () => import(`@/layouts/${path}.vue`).then((m) => m.default || m);
};

export default [
  {
    path: "/",
    name: "HomeQuiz",
    components: {
      default: p("HomeQuiz"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "List Quiz",
    },
  },
  {
    path: "/quiz/:id",
    name: "QuizPage",
    components: {
      default: p("QuizPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "Quiz Page",
    },
  },
  {
    path: "/goi",
    name: "GoiPage",
    components: {
      default: p("GoiPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "Goi Page",
    },
  },
  {
    path: "/goi/exam/:id",
    name: "GoiExamPage",
    components: {
      default: p("GoiExamPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "Goi Exam Page",
    },
  },
  {
    path: "/jlpt-test",
    name: "JlptTestPage",
    components: {
      default: p("JlptTestPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "JLPT Test",
    },
  },
  {
    path: "/jlpt-test/:id",
    name: "JlptTestAttemptPage",
    components: {
      default: p("JlptTestAttemptPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "JLPT Test",
    },
  },
  {
    path: "/kotoba/:id",
    name: "KotobaQuizPage",
    components: {
      default: p("QuizPageMultiple"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "言葉ページ",
    },
  },
  {
    path: "/preview/:id",
    name: "PreviewPage",
    components: {
      default: p("PreviewPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "言葉ページ",
    },
  },
  {
    path: "/kanji/:id",
    name: "KanjiQuizPage",
    components: {
      default: p("QuizPageMultiple"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "漢字ページ",
    },
  },
  {
    path: "/upload-csv",
    name: "UploadCsv",
    components: {
      default: p("UploadCsvPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "Upload Csv",
    },
  },
  {
    path: "/kanji",
    name: "KanjiPage",
    components: {
      default: p("KanjiQuiz"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "Kanji Quiz",
    },
  },
  {
    path: "/grammar",
    name: "GrammarPage",
    components: {
      default: p("GrammarPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "Grammar",
    },
  },
  {
    path: "/mind-map",
    name: "MindMap",
    components: {
      default: p("MindMapPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "Grammar Mind Map",
    },
  },
  {
    path: "/reading",
    name: "ReadingPage",
    components: {
      default: p("ReadingPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresAuth: false,
      title: "Reading",
    },
  },
  {
    path: "/login",
    name: "Login",
    components: {
      default: p("LoginPage"),
      header: pl("MainHeader"),
      footer: pl("MainFooter"),
    },
    meta: {
      requiresVisitor: false,
    },
  },
];
